/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Injectable } from '@angular/core';
import { Confirm } from 'src/refresh/service/constant';
import { Util } from 'src/refresh/service/Util';
import { Limit } from '../constant/page-const';
var show = console.log.bind( console );

@Injectable({
  providedIn: 'root',
})



//--------------------------------------------------------------------------------
//   - for each child : this is injected in each page's class.
//--------------------------------------------------------------------------------
export class InputData {

      public eligibility:Eligibility;
      public aboutChild:AboutChild;
      public contact:Contact;

      public motherContact:Contact;
      public parents:ParentInfo[];                  // original list by input order
      public parentList:ParentInfo[]                // Mother first list
      public certifyingParents:Map<number,String>;  // Mother First only with certifying parents.
      public orderOfBC:OrderOfBC;

      public CCB:CCB;
      public SIN:SIN;
      public CESP:CESP;

      public applicantParent:ParentInfo; 

      public subject = new Subject();      
      public isNextChild:boolean = false;
      public isSubmit:boolean = false;

      public static moveNext:number = 0;
      public static currentPageIdx:number = 0;
      public static recoverNext:boolean = false;
      
      public init() {
            this.subject.index = 0;
            this.clear();
            this.newInputData();
      }

      private _value:string;
      public push(value:string) {
             this._value = value;
      }

      public pushed() : boolean {
             return !!this._value;
      }

      public pop() : string {
             if ( this._value ) {
                  let ret = this._value;
                  this._value = null;
                  return ret;
             }
             return null;
      }

      public getBirthParent():ParentInfo {

             let idx = this.getBirthParentIndex();
             if ( idx >= 0 ) return this.parents[idx];
             return null;
      }

      public getBirthParentIndex():number{

            for ( let i = 0; i < this.eligibility.listedParentCount; i++ ) {
                  if ( this.parents[i].isGiveBirth == 'Y' ) return i;
            }
            return -1;
     }

     public setParentCount(count:number) {

            this.eligibility.listedParentCount = count;
            if ( this.parents.length > count  ) {
                 this.parents.length = count;
                 this.parentList.length = count;
            }
            else
            if ( this.parents.length < count  ) {
                 for ( let i = this.parents.length; i < count; i++ ) {
                       this.parents[i] = new ParentInfo();
                       this.parentList[i] = new ParentInfo();
                 }
            }
      }

      public addChild(birthDay:string,isChildDeceased:string,isSameAddr:String) {

             this.subject.total += this.orderOfBC.total;
             
             let oldData:InputData = this.subject.inputDataList[this.subject.index-1];

             this._clear();

             this.newInputData();

             this.aboutChild.copyFrom(oldData.aboutChild);
             this.aboutChild.birthDay = birthDay;
             this.aboutChild.isChildDeceased = isChildDeceased;

             //console.log( oldData.aboutChild.birthDay, oldData.aboutChild.isChildDeceased);
             //console.log( this.aboutChild.birthDay, this.aboutChild.isChildDeceased);

             this.setParentCount(this.eligibility.listedParentCount);
             
             for ( let i = 0; i < this.eligibility.listedParentCount; i++ ) {
                   this.parents[i].copyFrom(oldData.parents[i]);
                   this.parentList[i].copyFrom(oldData.parentList[i]);
             }

             this.isNextChild = true;
             this.contact.copyFrom(oldData.contact);
             this.motherContact.copyFrom(oldData.motherContact);

             this.contact.notEditable = (isSameAddr == Confirm.YES);
             
             let first:InputData = oldData;

             this.CCB.careGiver = first.CCB.careGiver;
             this.CCB.primaryCaregiver = first.CCB.primaryCaregiver;
             this.CCB.SSN1 = first.CCB.SSN1;
             this.CCB.SSN2 = first.CCB.SSN2;
             this.CCB.SSN3 = first.CCB.SSN3;

             if ( first.CCB.chk_consent || first.CCB.isLocked ) { 
                  this.CCB.isLocked = true;
             }

             this.ESRCopy(oldData);
      }

      private ESRCopy(oldData:InputData) {

              let idx = this.subject.index-1;
              let cesp:CESP = oldData.CESP;
              while ( !cesp.chk_consent ) {
                      if ( idx-- <= 0 ) return;
                      cesp = this.subject.inputDataList[idx].CESP;
              }
              
              this.CESP.contactParent = cesp.contactParent;
              this.CESP.promoter = cesp.promoter;
              this.CESP.postalCode = cesp.postalCode;
              this.CESP.country = cesp.country;
              this.CESP.contactLang = cesp.contactLang;
              this.CESP.contactMethod = cesp.contactMethod;
              this.CESP.contactEmail = cesp.contactEmail;

              this.CESP.firstArea = cesp.firstArea;
              this.CESP.firstNumber1 = cesp.firstNumber1;
              this.CESP.firstNumber2 = cesp.firstNumber2;
              this.CESP.firstExt = cesp.firstExt;
              this.CESP.firstTTY = cesp.firstTTY;

              this.CESP.secondArea = cesp.secondArea;
              this.CESP.secondNumber1 = cesp.secondNumber1;
              this.CESP.secondNumber2 = cesp.secondNumber2;
              this.CESP.secondExt = cesp.secondExt;
              this.CESP.secondTTY = cesp.secondTTY;

              this.CESP.contactTime = cesp.contactTime;
              this.CESP.emailForReceipt = cesp.emailForReceipt;
              this.CESP.category = cesp.category;
      }
      
      public removeChild(): InputData{

             if ( this.subject.index <= 1 ) return;
             this.subject.index--;

             let inputData:InputData = this.subject.inputDataList[this.subject.index-1];

             this.eligibility   = inputData.eligibility;
             this.aboutChild    = inputData.aboutChild;
             this.motherContact = inputData.motherContact;
 
             this.contact   = inputData.contact;
             this.parents   = inputData.parents;
             this.parentList = inputData.parentList;
             this.orderOfBC = inputData.orderOfBC;
             this.certifyingParents = inputData.certifyingParents;
             
             this.CCB  = inputData.CCB;
             this.SIN  = inputData.SIN;
             this.CESP = inputData.CESP;

             this.subject.total -= this.orderOfBC.total;
             
             if ( this.subject.index == 1 ) this.isNextChild = false;

             return inputData;
      }

      public newInputData() {

            let inputData = new InputData();

            inputData.eligibility   = this.eligibility;
            inputData.aboutChild    = this.aboutChild;
            inputData.motherContact = this.motherContact;

            inputData.contact   = this.contact;
            inputData.parents   = this.parents;
            inputData.parentList = this.parentList;
            inputData.orderOfBC = this.orderOfBC;
            inputData.certifyingParents = this.certifyingParents;
            
            inputData.CCB  = this.CCB;
            inputData.SIN  = this.SIN;
            inputData.CESP = this.CESP;

            inputData.subject = this.subject;

            this.subject.inputDataList[this.subject.index++] = inputData;
      }

      private _clear() {
                  this.aboutChild  = new AboutChild();
                  this.contact  = new Contact();
                  this.motherContact = new Contact();
                  this.parents  = [];
                  this.parentList = [];
                  this.certifyingParents  = new Map<number,String>();

                  this.orderOfBC = new OrderOfBC();
                  this.CCB = new CCB();
                  this.SIN = new SIN();
                  this.CESP = new CESP();
                  this.eligibility.birthCertifyConsent = "";
                  this.eligibility.chkAgreeToLastName = "";
                  this.eligibility.chkReadDisclosure = "";
      }

      public clear() {
             this.eligibility = new Eligibility();  
             this._clear();
      }

      public clearSINParent() {
            for ( let i = 0; i < this.eligibility.listedParentCount; i++ )
                  if ( this.parentList[i] ) this.parentList[i].isSINParent = false;
      }
}

//--------------------------------------------------------------------------------
//   - InputData(Child) holder , up to 5 
//--------------------------------------------------------------------------------
export class Subject {
       inputDataList:InputData[] = new Array(Limit.Children);
       index:number = 0;
       total:number = 0;
       language:string = "en";
       showHeader:boolean = false;
       captcha:string;
       siteKey:string;
       hasError:boolean = false;

       public containsBirthOrder(birthOrder:string):boolean {
              for ( let i = 0; i < this.index-1; i++ ) {
                    if ( this.inputDataList[i].aboutChild.birthOrder == birthOrder ) return true;
              }
              return false;
       }
}

//--------------------------------------------------------------------------------
//   - Parents Name and Child Name
//--------------------------------------------------------------------------------
export class Name {
      private  _first:string  = "";
      private  _middle:string = "";
       chk_middleNA:boolean = false;

       private  _last:string = "";  
       chk_singleName:string = "";
       private  _single:string = "";

      public get first() : string {
             return this._first;
      }

      public set first(value:string) {
             if ( value ) this._first = value.trim();
             else this._first = '';
      }

      public get middle() : string {
            return this._middle;
      }

      public set middle(value:string) {
             if ( value ) this._middle = value.trim();
             else this._middle = '';
      }

      public get last() : string {
              return this._last;
      }

      public set last(value:string) {
              if ( value ) this._last = value.trim();
              else this._last = '';
      }

      public get single() : string {
              return this._single;
      }

      public set single(value:string) {
              if ( value ) this._single = value.trim();
              else this._single = '';
      }

      public getFullName():string  {
              if ( this.chk_singleName == Confirm.YES ) {
                   return this._single;
              }

              let fullName = this._last;
              
              if ( this.middle ) fullName = this._middle + " " + fullName;
              if ( this.first  ) fullName = this._first  + " " + fullName;

              return fullName;
       }

       public completed():boolean{

              //if ( this._last && this._first ) return true;
              if ( this._last  || this._single ) return true;

              return false;
       }

       public getSingleOrLast() : string {
              if ( this.chk_singleName == Confirm.YES ) 
                   return this.single;
              else return this.last;
       }

       public copyFrom(other:Name) {
              this._first = other._first;
              this._middle = other._middle;
              this.chk_middleNA = other.chk_middleNA;
              this._last = other._last;
              this.chk_singleName = other.chk_singleName;
              this._single = other._single;
       }

       public clear() {
              this._first = "";
              this._middle = "";
              this.chk_middleNA = false
              this._last = "";
              this._single = "";
       }
}

//--------------------------------------------------------------------------------
//    PlaceOfBirth in Parents
//--------------------------------------------------------------------------------
export class BaseAddress {
     city:string = "";
     province:string = "";
     chk_province:boolean = false;
     country:string  = "";
     otherCountry:string = "";

     birthPlace:string = "";  

     public copyFrom(other:BaseAddress) {
            this.city     = other.city;
            this.province = other.province;
            this.chk_province = other.chk_province;
            this.country  = other.country;
            this.otherCountry = other.otherCountry;
            this.birthPlace   = other.birthPlace;
     }
}

//--------------------------------------------------------------------------------
//    Contact : unit is only for Canada,   poBox is only for International.
//--------------------------------------------------------------------------------
export class Address {

      chk_international: string = "";

      streetNumber:string = "";
      streetName:string = "";

      unit:string = "";
      chk_unitNA:boolean = false;

      buzz:string = "";
      chk_buzzNA:boolean = false;

      poBox:string = "";
      chk_poBox:boolean = false;
      
      base:BaseAddress = new BaseAddress();

      postalCode:string = "";
      
      deliveryNeed:string = "";
      deliveryMode:string = "";
      deliveryAddr:string = "";

      public copyFrom(other:Address) {

            this.chk_international = other.chk_international;

            this.streetNumber = other.streetNumber;
            this.streetName   = other.streetName;
      
            this.unit = other.unit;
            this.chk_unitNA = other.chk_unitNA;
      
            this.buzz = other.buzz;
            this.chk_buzzNA = other.chk_buzzNA;
      
            this.poBox = other.poBox;
            this.chk_poBox = other.chk_poBox;
            
            this.base.copyFrom(other.base);
      
            this.postalCode = other.postalCode;
 
            this.deliveryNeed = other.deliveryNeed;
            this.deliveryMode = other.deliveryMode;
            this.deliveryAddr = other.deliveryAddr;
      }
}



//--------------------------------------------------------------------------------
//     setup 1 to 5
//--------------------------------------------------------------------------------
export class Eligibility {
      isBornInOntario:string; 
      isOneYearMore:boolean;

      isUnableToCertify:string; 

      isBornThroughSurrogacy:string; 
      isCustodyOtherThanParent:string;
      isOtherCertifyingBirth:string;   // other who is not parent.

      otherFirstName:string = "";
      otherLastName:string = "";
      otherSingleName:string = "";
      isOtherSingleName:string;
      
      birthType:string = "";         // is multipleBirth?
      deliveredByOther:string = "";  // otherThanDoctor?

      listedParentCount:number = 0;
      certifyingParentCount:number = 0;

      whichParentCertifying:string;  // it is for the Parent Page
      //-------final review
      birthCertifyConsent: string;
      chkAgreeToLastName: string;
      chkReadDisclosure: string;
}

//--------------------------------------------------------------------------------
//     About Child Page
//--------------------------------------------------------------------------------
export class AboutChild {

       name = new Name();
       //-----------------------------------
       birthDay:string  = "";   // input in Eligibility
       isChildDeceased:string;  // input in Eligibility
       birthOrder:string = "";         // is multipleBirth?
       //-----------------------------------
       nextBirthDay:string  = ""; 
       nextChildDeceased:string;  
       isNextChild:string;
       isSameAddress:string;
       isSameBirthday:string;
       //-----------------------------------

       isParentAgreeOnLastName:string = "";
       isParentAgreeOnSingleName:string = "";

       //------------------------------------------------------------
       gender:string = "";
       grams:number;
       pounds:number;
       ounces:number;

       //------------------------------------------------------------
       cityTown:string = "";         // city / town
       cityName:string = "";         // Internal Use.
       region:string;

       otherCity:string = "";        // if city is not found in list.

       birthPlaceType:string = "";     // home, hospital, birthCenter : where Child Born?
       birthPlaceCode:string = "";     // hospitalCode or BirhCenterCode
       birthPlaceName:string = "";     
       otherBirthPlace:string = "";    // if BirhPlace is not found in list.

       birthStreetName:string = "";
       birthStreetNumber:string = "";

       //------------------------------------------------------------
       attendentType :string = "";       // doctor , midwife or someone else
       attendentFirstName :string = "";  //
       attendentLastName :string = "";   // 
       attendentSingleName :string = ""; // 
       attendentTitle:string = "";       // for someone else

       isDoctorSingleName:string = "";
       isMidwifeSingleName:string = "";
       isSomeoneElseSingleName:string = "";

       public copyFrom(other:AboutChild) {
              this.cityTown  = other.cityTown;
              this.otherCity = other.otherCity;
              this.birthPlaceType = other.birthPlaceType;
              this.birthPlaceCode = other.birthPlaceCode;
              this.otherBirthPlace = other.otherBirthPlace;
              this.birthStreetName = other.birthStreetName;
              this.birthStreetNumber = other.birthStreetNumber;

              this.attendentType = other.attendentType;
              this.attendentFirstName = other.attendentFirstName;
              this.attendentLastName = other.attendentLastName;
              this.attendentTitle = other.attendentTitle;

              this.isDoctorSingleName = other.isDoctorSingleName;
              this.isMidwifeSingleName = other.isMidwifeSingleName;
              this.isSomeoneElseSingleName = other.isSomeoneElseSingleName;
       }

       public backup(other:AboutChild) {
              this.copyFrom(other);

              this.birthOrder = other.birthOrder;
              this.gender  = other.gender;
              this.grams   = other.grams;
              this.pounds  = other.pounds;
              this.ounces  = other.ounces;
              this.name.copyFrom( other.name );
       }

}

//--------------------------------------------------------------------------------
//     About Parent Page
//--------------------------------------------------------------------------------
export class ParentInfo {

      name = new Name();

      isOtherLastNameAtBirth:string;
      lastNameAtBirth:string = "";
      isOtherPreviousName:string;
      previousLastName:string = "";
      
      parentType:string = "";
      parentTitle:number;  // for internal purpose 

      whenParentBorn:string = "";

      placeOfBirth = new BaseAddress();

      isCertifyingParent:string = "";    // ?
      isLastNameAgreed:boolean = false;
      isLastNameLocked:boolean = false;

      isGiveBirth:string = "";      

      isSINParent:boolean = false;

      //-- this is only for Birth Parenbt :  when isGiveBirth == 'Y'
      isPreviousBirth:string = "";
      maritalStatus:string = "";
      pregnancyDuration:number;      
      howManyLiveborn:number;      
      howManyStillborn:number;      

      isASNOpen:boolean = false;

      //-----------------------------------------
      public copyFrom(other:ParentInfo) {

             this.name.copyFrom(other.name);      

             this.isOtherLastNameAtBirth = other.isOtherLastNameAtBirth;
             this.lastNameAtBirth = other.lastNameAtBirth;
             this.isOtherPreviousName = other.isOtherPreviousName;
             this.previousLastName = other.previousLastName;
             
             this.parentType = other.parentType;

             
             this.isGiveBirth   = other.isGiveBirth;

             this.isPreviousBirth   = other.isPreviousBirth;
             this.maritalStatus = other.maritalStatus;
             this.pregnancyDuration      = other.pregnancyDuration;
             this.howManyLiveborn   = other.howManyLiveborn;
             this.howManyStillborn  = other.howManyStillborn;

             //---------------------------
             this.whenParentBorn = other.whenParentBorn;
             this.placeOfBirth.copyFrom( other.placeOfBirth );

             this.isCertifyingParent     = other.isCertifyingParent;
             this.isLastNameAgreed       = other.isLastNameAgreed;
      }
}

//--------------------------------------------------------------------------------
//     Contact Info And Mailing Address
//--------------------------------------------------------------------------------
export class Contact {
       notEditable:boolean;
       isParentSameAddr:string;
       phoneArea:string = "";        
       phoneNumber1:string = "";        
       phoneNumber2:string = "";        
       phoneExt:string = "";        

       daytimePhoneArea:string  = "";        
       daytimePhoneNumber1:string = "";        
       daytimePhoneNumber2:string = "";        
       daytimeExt:string  = "";        

       address:Address = new Address();

       needSpecialDelivery:string;

       public phoneNumber(div?:string) : string {
              if ( !div )  div = '';
              let phone4:string = this.phoneNumber2;
              if ( this.address.chk_international != Confirm.YES ) phone4 = Util.padZero(this.phoneNumber2,4)
              return  this.phoneArea + div + this.phoneNumber1 + div + phone4;
       }

       public dayTimeNumber(div?:string) : string {
              if ( !div )  div = '';
              let phone4:string = this.daytimePhoneNumber2;
              if ( this.address.chk_international != Confirm.YES ) phone4 = Util.padZero(this.daytimePhoneNumber2,4)
              if ( this.daytimePhoneArea && this.daytimePhoneNumber1 && this.daytimePhoneNumber2) 
                   return  this.daytimePhoneArea + div + this.daytimePhoneNumber1 + div + phone4;
              else return "";
       }

       public copyFrom(other:Contact) {

            this.isParentSameAddr = other.isParentSameAddr;
            this.phoneArea = other.phoneArea;
            this.phoneNumber1 = other.phoneNumber1;
            this.phoneNumber2 = other.phoneNumber2;
            this.phoneExt = other.phoneExt;

            this.daytimePhoneArea = other.daytimePhoneArea;
            this.daytimePhoneNumber1 = other.daytimePhoneNumber1;
            this.daytimePhoneNumber2 = other.daytimePhoneNumber2;
            this.daytimeExt = other.daytimeExt;
            this.address.copyFrom(other.address);
            this.needSpecialDelivery = other.needSpecialDelivery;
       }
}

//--------------------------------------------------------------------------------
//     Birth Certificate Order Page
//--------------------------------------------------------------------------------
export class OrderOfBC {

       hasBCWithParentInfo:string;  // checkbox ( add to order )

       isReviewOtherTypeBC:string; // Yes No Radio

       hasBirthCertificate:string;  // checkbox ( add to order )

       hasCertifiedCopyOfBR:string; // checkbox ( add to order )

       applicantIndex:number = -1;  //  0-3 : parent index.   99:other
       organizationForOther:string;

       chk_BCConsent:string = ""; // checkbox : confirm  // main.key

       total:number = 0;          // main.key           
       amountForBCWithParent:number = 0;
       amountForBC:number = 0;
       amountForCertifiedCopy:number = 0;

       public clear() {
            this.hasBCWithParentInfo  = "";
            this.isReviewOtherTypeBC  = "";
            this.hasBirthCertificate  = "";
            this.hasCertifiedCopyOfBR = "";
            this.organizationForOther = "";

            this.applicantIndex = -1;
            this.chk_BCConsent  = "";

            this.total  = 0;          
            this.amountForBCWithParent = 0;
            this.amountForBC = 0;
            this.amountForCertifiedCopy = 0;
       }

       public backup(other:OrderOfBC) {
            this.hasBCWithParentInfo  = other.hasBCWithParentInfo;
            this.isReviewOtherTypeBC  = other.isReviewOtherTypeBC;
            this.hasBirthCertificate  = other.hasBirthCertificate;
            this.hasCertifiedCopyOfBR = other.hasCertifiedCopyOfBR;
            this.organizationForOther = other.organizationForOther;

            this.applicantIndex = other.applicantIndex;
            this.chk_BCConsent  = other.chk_BCConsent;
       }
}



//--------------------------------------------------------------------------------
//     CCB Order Page
//--------------------------------------------------------------------------------
export class CCB {
       careGiver:string = "";   
       primaryCaregiver:number = -1;
       SSN1:string = "";
       SSN2:string = "";
       SSN3:string = "";
       chk_consent:boolean = false;    // main.key
       emailForReceipt:string = "";  

       isLocked:boolean = false;
       isFromAreYourSure:boolean = false;

       public clear() {
            this.careGiver = "";   
            this.primaryCaregiver = -1;
            this.SSN1 = "";
            this.SSN2 = "";
            this.SSN3 = "";
            this.chk_consent = false;    
            this.emailForReceipt = "";  
      }

      public backup(other:CCB) {
            this.careGiver = other.careGiver;
            this.primaryCaregiver = other.primaryCaregiver;
            this.SSN1 = other.SSN1;
            this.SSN2 = other.SSN2;
            this.SSN3 = other.SSN3;
            this.chk_consent = other.chk_consent;
      }
}

//--------------------------------------------------------------------------------
//     SIN Order Page
//--------------------------------------------------------------------------------
export class SIN {
       chk_read:boolean = false;        // main.key
       chk_certify:String = "";
       bkSINParent: boolean[] = new Array(4);

       public clear() {
            this.chk_read  = false;        
            this.chk_certify  = "";
       }

       public backup(otherData:InputData) {
              this.chk_read    = otherData.SIN.chk_read;;        
              this.chk_certify = otherData.SIN.chk_certify;
              for ( let i = 0; i < otherData.eligibility.listedParentCount; i++ )   
                    this.bkSINParent[i] = otherData.parents[i].isSINParent;
       }

}

//--------------------------------------------------------------------------------
//     CESP Order Page
//--------------------------------------------------------------------------------
export class CESP {

       contactParent:number = -1;
       promoter:string = "";
       chk_consent:boolean = false;         // main.key

       postalCode:string = "";
       country:string = "";

       contactLang:string; // enlish(1) or french(2)

       contactMethod:string ; //phone(1)  email(2)
       contactEmail:string = "";

       firstArea:string;        
       firstNumber1:string;        
       firstNumber2:string; 
       firstExt:string;       
       firstTTY:number = 0;        

       secondArea:string;        
       secondNumber1:string;        
       secondNumber2:string;
       secondExt:string;    
       secondTTY:number = 0;            

       contactTime:number; //morning(1)  evening(2)  anytime(3)
       emailForReceipt:string = "";  //?

       //-----------------------------------------------------------
       category:string = "";
       chk_disclaimer:boolean = false;
       chk_privacy:boolean = false;
       chk_disclosure:boolean = false;

       public clear() {
            this.contactParent = -1;
            this.promoter = "";
            this.chk_consent = false;         // main.key
     
            this.postalCode = "";
            this.country = "";
     
            this.contactLang = undefined; // enlish(1) or french(2)
     
            this.contactMethod ; //phone(1)  email(2)
            this.contactEmail = undefined;
     
            this.firstArea = "";        
            this.firstNumber1 = "";        
            this.firstNumber2 = "";        
            this.firstExt = "";        
            this.firstTTY = 0;        
     
            this.secondArea = "";        
            this.secondNumber1 = "";        
            this.secondNumber2 = "";        
            this.secondExt = "";        
            this.secondTTY = 0;            
     
            this.contactTime = undefined; //morning(1)  evening(2)  anytime(3)
            this.emailForReceipt = "";  //?
     
            //-----------------------------------------------------------
            this.category = "";
            this.chk_disclaimer = false;
            this.chk_privacy = false;
            this.chk_disclosure = false;
       }

       public backup(other:CESP) {
            this.contactParent = other.contactParent;
            this.promoter = other.promoter;
            this.chk_consent = other.chk_consent;
     
            this.postalCode = other.postalCode;
            this.country = other.country;
     
            this.contactLang = other.contactLang;
     
            this.contactMethod = other.contactMethod;
            this.contactEmail = other.contactEmail;
     
            this.firstArea = other.firstArea;
            this.firstNumber1 = other.firstNumber1;
            this.firstNumber2 = other.firstNumber2;
            this.firstExt = other.firstExt;
            this.firstTTY = other.firstTTY;
     
            this.secondArea = other.secondArea;
            this.secondNumber1 = other.secondNumber1;
            this.secondNumber2 = other.secondNumber2;
            this.secondExt = other.secondExt;
            this.secondTTY = other.secondTTY;
     
            this.contactTime = other.contactTime;
     
            //-----------------------------------------------------------
            this.category = other.category;
            this.chk_disclaimer = other.chk_disclaimer;
            this.chk_privacy = other.chk_privacy;
            this.chk_disclosure = other.chk_disclosure;
       }


}

export class Facility {
      public facilityCode:string;
      public streetNumber:string;
      public streetName:string;
      public postalCode:string;
}

